
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      this.attachListeners();
      this.setHeaderCartIconAccessibility();
      document.addEventListener('td-cart-refreshed', this.attachListeners.bind(this))
    });
  }
  attachListeners() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    document.addEventListener('td-cart-updated', this.handleCartUpdate.bind(this))
    document.addEventListener('td-cart-refreshed', this.handleCartRefresh.bind(this))
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }
  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.th-cart-link-trigger');
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  handleCartUpdate(e) {
    this.renderContents(e.detail)
    this.attachListeners();
    if (window.affirm && window.affirm.jsReady()) {
      window.affirm.ui.refresh()
    }
    this.open()
    
  }
  handleCartRefresh() {
    if (window.affirm && window.affirm.jsReady()) {
      window.affirm.ui.refresh()
    }
    this.updateQuantityIcons();
  }

  open(triggeredBy) {
    if (window.location.pathname === "/cart") return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    let root = document.querySelector('html');
    if (!root) {return}
    root.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    let root = document.querySelector('html');
    if (!root) {return}
    root.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (this.querySelector('.drawer__inner')) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (!parsedState.sections[section.id]) return
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.updateQuantityIcons();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'th-cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateQuantityIcons() {
    const quantityInputs = this.querySelectorAll('input[data-cart-quantity]');
    quantityInputs.forEach(input => {
      const quantity = parseInt(input.value);
      const minusButton = input.previousElementSibling;
      
      if (quantity === 1) {
        // Show trash icon, hide minus icon
        minusButton.classList.add('show-trash');
      } else {
        // Show minus icon, hide trash icon
        minusButton.classList.remove('show-trash');
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'th-cart-drawer',
        section: 'th-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class AffirmWrapper extends HTMLElement {
  constructor() {
    super();
    this.initialized = false
  }
  connectedCallback() {
    setTimeout(() => {
      if (window.affirm) {
        const affirmInterval = setInterval(() => {
          if (window.affirm?.jsReady()) {
            this.updateCustomAffirm()
            if (this.initialized) {
              clearInterval(affirmInterval)
            }
          }
        })
      }
    });
  }
  updateCustomAffirm() {
    // TODO clean this up
    setTimeout(() => {
      const affirmContent = this.querySelector('.affirm-as-low-as')
      const promoWrapper = this.querySelector('.promo-component-wrapper')
      if (affirmContent && promoWrapper) {
        
        try {
          const handleUI = () => {
            affirm.ui.components.create('promo',{pageType:'product', amount: parseInt(affirmContent.dataset.amount)}).render('.td--cart__affirm.affirm-as-low-as')
            const copy = affirmContent.outerHTML.replace('/mo ','/MONTH ').replace('available ','available with ').replace('Starting at ','As Low As ').replace('or 0% APR', '').replace('. ','').replace('or as low as', 'PAY AS LOW AS')
            promoWrapper.innerHTML = ''
            promoWrapper.innerHTML = copy
            if (!promoWrapper.classList.contains('active')) {
              promoWrapper.classList.add('active')
            }
          }
          if (affirmContent.innerText?.length) {
            handleUI()
          } else {

          }
          const callback = (mutationList, observer) => {
            handleUI()
          };
          
          const config = { attributes: true, childList: true, subtree: true };
          // Create an observer instance linked to the callback function
          const observer = new MutationObserver(callback);
          observer.observe(affirmContent, config)
        
        }catch(err) {
          console.log(err)
          promoWrapper.remove()
        }
        
        
        this.initialized = true
      }
    }, 100)
    
  }
}

customElements.define('affirm-wrapper', AffirmWrapper);